<template>
  <div class="vx-row pa-5">

    <div class="vx-col md:w-full px-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <p class="mb-4"><strong>Set a new password</strong></p>
          <p>A Starling Administrator has provided you with a temporary password. You must now set your own permanent
            password for security reasons.</p>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mt-5 w-full">
          <form autocomplete="on">
            <vs-input
              ref="newPassword"
              id="new-password"
              name="new-password"
              autocomplete="new-password"
              class="w-full mt-2"
              label="New Password"
              v-model="newPassword"
              :type="newPasswordVisible ? 'text' : 'password'"
              icon-no-border
              icon-pack="feather"
              :icon="newPasswordVisible ? 'icon icon-unlock' : 'icon icon-lock'"
              v-on:icon-click="newPasswordVisible = !newPasswordVisible"
              v-on:input="errorMessageDoesntMatch = false"
              v-validate="{ required: true, min: 12, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&,:;<>~_=\*\.\$\^\(\)\{\}\[\]\?\+\-\|\/\\]).{12,60}/ }"
              data-vv-as="New Password"
              :danger="errors.has('new-password')"
              :danger-text="errors.first('new-password')"/>

            <vs-input
              id="confirm-password"
              name="confirm-password"
              autocomplete="confirm-password"
              class="w-full mt-2"
              label="Password Confirmation"
              :type="newPasswordConfirmationVisible ? 'text' : 'password'"
              v-model="newPasswordConfirmation"
              icon-no-border
              icon-pack="feather"
              :icon="newPasswordConfirmationVisible ? 'icon icon-unlock' : 'icon icon-lock'"
              v-on:icon-click="newPasswordConfirmationVisible = !newPasswordConfirmationVisible"
              v-on:input="errorMessageDoesntMatch = false"
              v-validate="'required|confirmed:newPassword'"
              data-vv-as="Password Confirmation"
              :danger="errors.has('confirm-password')"
              :danger-text="errors.first('confirm-password')"/>
          </form>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-5 w-full">
          <p class="font-semibold mb-2">Password Requirements:</p>
          <ul class="pl-8" style="list-style-type: circle;">
            <li>Minimum 12 characters long</li>
            <li>At least one uppercase character</li>
            <li>At least one lowercase character</li>
            <li>At least one number</li>
            <li>At least one symbol</li>
          </ul>
        </div>

        <div class="vx-col mt-5 w-full">
          <vs-alert color="danger" :active="errorMessage" class="mt-5 mb-5">
            Changing your password cannot be done. Please make sure the current password is correct.
          </vs-alert>
          <vs-alert color="danger" :active="errorMessageDoesntMatch" class="mt-5 mb-5">
            The password confirmation does not match
          </vs-alert>
          <vs-alert :active="!errorMessage" class="mt-5 mb-5">
            Please enter your new password and confirmation to change it.
          </vs-alert>
        </div>
      </div>
    </div>


    <div class="vx-col mt-5 w-full">
      <div class="vx-row justify-center mt-10">
        <div class="vx-col justify-center">
          <vs-button class="mr-1" @click="onSubmit" :disabled="errors.any() || !isFormDirty || loading">Set my
            password
          </vs-button>
          <vs-button class="ml-1" type="flat" @click="onCancel" :disabled="loading">Cancel</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Auth} from 'aws-amplify';

/* eslint-disable security/detect-object-injection */
export default {
  name: 'security-temporary-password-setup',
  props: {
    cognitoUser: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      newPassword: null,
      newPasswordConfirmation: null,
      newPasswordVisible: false,
      newPasswordConfirmationVisible: false,
      errorMessage: false,
      errorMessageDoesntMatch: false
    };
  },
  computed: {
    isFormDirty () {
      return Object.keys(this.fields).some(key => this.fields[key] && this.fields[key].dirty);
    }
  },
  mounted () {
  },
  methods: {
    onCancel () {
      this.$emit('updated', false);
    },
    onSubmit () {
      this.loading = true;
      Auth.completeNewPassword(this.cognitoUser, this.newPassword).then(res => {
        if (res.challengeName === 'SOFTWARE_TOKEN_MFA') {
          this.$router.push({
            name: 'page-login',
            params: {cognitoUser: res, newPassword: this.newPassword}
          });
        } else if (res.challengeName === 'MFA_SETUP' || this.enforceMFA === true) {
          this.$router.push({
            name: 'page-configure-mfa',
            params: {cognitoUser: res}
          });
        } else {
          const session = Auth.currentSession();
          return session.then(tokens => {
            const key = tokens.getAccessToken().jwtToken;
            this.$store.commit('account/setAccessToken', key);
            this.errorMessage = null;
            return this.$store.state.router.publicRoot.$request().$post('sign_in_cognito', null, {
              username: this.cognitoUser.username,
              password: this.newPassword
            }).then(() => {
              return this.$store.state.router.apiRoot.$request().$getSelf().then(root => {
                this.$store.commit('router/updateRouteProp', {
                  property: 'apiRoot',
                  value: root
                });
                this.$vs.notify({
                  title: 'Password changed',
                  text: 'Your account password has been changed.',
                  iconPack: 'feather',
                  icon: 'icon-check-circle',
                  color: 'success'
                });
                this.$emit('updated', true);
              });
            });
          });
        }
      }).catch(err => {
        this.$log.error(err);
        this.verificationError = true;
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
